import React from "react"
import styled, { css } from "styled-components"
import Slider, { Settings } from "react-slick"
import { media } from "../../../../style/const/media-query"
import banner1 from "./img/1.jpg"
import banner2 from "./img/2.jpg"
import banner3 from "./img/3.jpg"
import banner4 from "./img/4.png"

interface IBanner {
  link: string
  imgUrl: string
}

const bannerData: IBanner[] = [
  {
    link: "/channel/sabay",
    imgUrl: banner4,
  },
  {
    link: "/channel/futuring",
    imgUrl: banner3,
  },
  {
    link: "/channel/startups",
    imgUrl: banner2,
  },
  {
    link: "/channel/public_relations",
    imgUrl: banner1,
  },
]

export class Banner extends React.Component {
  public componentDidMount(): void {
    const links = [
      "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css",
      "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css",
    ]
    links.forEach(l => {
      if (!document.querySelector(`[href="${l}"]`)) {
        const link = document.createElement("link")
        link.setAttribute("rel", "stylesheet")
        link.setAttribute("href", l)
        document.head.appendChild(link)
      }
    })
  }

  public render() {
    const settings: Settings = {
      autoplay: true,
      autoplaySpeed: 5000,
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      variableWidth: true,
      arrows: true,
      swipe: true,
      draggable: true,
    }

    // Linkにすると以下の問題が起きるのでaタグで回避しています
    // TODO: onMouseMoveなどから厳密にクリックのみリンク先に遷移するようにする
    // https://github.com/akiran/react-slick/pull/1483
    return (
      <Wrapper>
        <StyledSlider {...settings}>
          {bannerData.map(d => (
            <a href={d.link} key={d.link}>
              <img alt={"バナー画像"} src={d.imgUrl} />
            </a>
          ))}
        </StyledSlider>
      </Wrapper>
    )
  }
}

const StyledSlider = styled(Slider)`
  ${media.desktop(css`
    height: 0;
    padding-bottom: 300px;
  `)}
  ${media.tablet(css`
    height: 0;
    padding-bottom: 39.5%;
  `)}
  .slick-slide {
    width: 100vw !important;
    max-width: 768px !important;
  }
`

const Wrapper = styled.div`
  width: 100vw;
  overflow: hidden;
  padding-bottom: 45px;
`
